document.addEventListener("input", function () {

  let width = parseFloat(document.querySelector("#width_mm")?.value) || 0;
  let height = parseFloat(document.querySelector("#height_mm")?.value) || 0;

  let sqft = (width * height) / 92900;

  let rate = parseFloat(document.querySelector("#rate")?.value) || 6.5;

  let basePrice = sqft * rate;

  let minPrice = parseFloat(document.querySelector("#min_price")?.value) || 0;

  let finalPrice = Math.max(basePrice, minPrice);

  let output = document.querySelector("#calculated_price");

  if (output) {
    output.innerText = "$" + finalPrice.toFixed(2);
  }

  // cart sync
  document.querySelector("#cart_width").value = width;
  document.querySelector("#cart_height").value = height;
  document.querySelector("#cart_sqft").value = sqft.toFixed(2);
  document.querySelector("#cart_price").value = finalPrice.toFixed(2);

});